enum SettingsDisplayType {
    Card = "card",
    Accordion = "Accordion",
    List = "list"
}

export default SettingsDisplayType;
